'use strict';

var Api = require('@sendsprint/api-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Api__default = /*#__PURE__*/_interopDefaultLegacy(Api);

const getCountryTelCode = (country) => {
    let telCode = "";
    switch (country) {
        case Api__default['default'].Model.CountryInitials.Canada:
            telCode = "+1";
            break;
        case Api__default['default'].Model.CountryInitials.UnitedKingdom:
            telCode = "+44";
            break;
        case Api__default['default'].Model.CountryInitials.UnitedStates:
            telCode = "+1";
            break;
        case Api__default['default'].Model.CountryInitials.Ghana:
            telCode = "+233";
            break;
        case Api__default['default'].Model.CountryInitials.Kenya:
            telCode = "+254";
            break;
        case Api__default['default'].Model.CountryInitials.Nigeria:
        case Api__default['default'].Model.CountryInitials.NigeriaNig:
            telCode = "+234";
            break;
        case Api__default['default'].Model.CountryInitials.SouthAfrica:
            telCode = "+27";
            break;
        default:
            telCode = "";
            break;
    }
    return telCode;
};

module.exports = getCountryTelCode;
